<form>
  <payee-chip-dropdown
    [displayWith]="displayWith"
    [placeholder]="'EVENTS.FILTERS.LABEL.LABEL' | translate"
    [selected]="selected"
    [(dropdownOpen)]="dropdownOpen"
    (removed)="clearFilter()"
  >
    <payee-form-field>
      <input
        payee-input
        [formControl]="labelControl"
        [placeholder]="'EVENTS.FILTERS.LABEL.PLACEHOLDER' | translate"
        (paste)="onPaste($event)"
      />
      @if (labelControl.invalid && labelControl.dirty) {
        <span payee-error>
          {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
        </span>
      }
    </payee-form-field>
    <button
      payee-button
      type="submit"
      class="top-margin-10"
      color="primary"
      (click)="applyFilter()"
    >
      {{ "EVENTS.FILTERS.APPLY" | translate }}
    </button>
  </payee-chip-dropdown>
</form>
